export interface Problem {
  type: string;
}

export function isProblem(response: any): response is Problem {
  return response.type !== undefined;
}
